import { Component, Inject, ChangeDetectionStrategy } from "@angular/core";
import { MAT_DIALOG_DATA } from "@angular/material/dialog";

@Component({
  standalone: false,
  selector: "app-help-tooltip",
  templateUrl: "./help-tooltip.component.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ["./help-tooltip.component.css"],
})
export class HelpTooltipComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: { helpTitle: string; helpText: string },
  ) {}
}
